import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';
import { currency } from '../../../../../../common/services/common.service';
import _ from 'lodash';

export default function SalesQuoteItemPropertiesComponent({ handleFormItemChange, selectedSalesQuoteItems, getProductImage, itemIndex }: any) {

    return (
        <>
            <AccordionContainer
                child={
                    <>
                        {_.map(selectedSalesQuoteItems, (cardValue: any, itemIndex: any) => (
                            <div className='px-4 pb-2 pt-4 text-sm rounded-lg mt-1 border-2 border-skin-ouprimary shadow-lg'>
                                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                                    <div>
                                        <InputLabelContainer label="Image" />
                                        <img
                                            alt="productImage"
                                            src={getProductImage(cardValue.ProductId)} width="48" height="48"
                                        />
                                    </div>

                                    <InputContainer
                                        label="Item Name"
                                        labelField="ItemName"
                                        list={cardValue?.combinations}
                                        name={cardValue?.ProductAttributeCombinationId}
                                        onValueChange={(event: any, newValue: any) => {
                                            handleFormItemChange({
                                                value: event.target.value,
                                                field: 'ProductAttributeCombinationId',
                                                idx: itemIndex
                                            });
                                        }}
                                        type="text"
                                        value={cardValue?.ProductAttributeCombinationId}
                                        valueField="ProductAttributeCombinationId"
                                    />

                                    <InputContainer
                                        label="Quantity"
                                        name="Quantity"
                                        onValueChange={(event: any) => {
                                            handleFormItemChange({
                                                value: event.target.value,
                                                field: 'Quantity',
                                                idx: itemIndex
                                            });
                                        }}
                                        type="number"
                                        value={cardValue?.Quantity}
                                    />
                                    <InputContainer
                                        label="Tax Percentage"
                                        name="TaxPercentage"
                                        onValueChange={(event: any) => {
                                            handleFormItemChange({
                                                value: event.target.value,
                                                field: 'TaxPercentage',
                                                idx: itemIndex
                                            });
                                        }}
                                        type="number"
                                        value={cardValue?.TaxPercentage}
                                    />
                                    <InputContainer
                                        label="Discount Percentage"
                                        name="DiscountPercentage"
                                        onValueChange={(event: any) => {
                                            handleFormItemChange({
                                                value: event.target.value,
                                                field: 'DiscountPercentage',
                                                idx: itemIndex
                                            });
                                        }}
                                        type="number"
                                        value={cardValue?.DiscountPercentage}
                                    />
                                    <InputContainer
                                        label="UnitPrice Incl Tax"
                                        name="UnitPriceInclTax"
                                        onValueChange={(event: any) => {
                                            handleFormItemChange({
                                                value: event.target.value,
                                                field: 'UnitPriceInclTax',
                                                idx: itemIndex
                                            });
                                        }}
                                        type="number"
                                        value={cardValue?.UnitPriceInclTax}
                                    />
                                    <InputContainer
                                        label="UnitPrice Excl Tax"
                                        name="UnitPriceExclTax"
                                        onValueChange={(event: any) => {
                                            handleFormItemChange({
                                                value: event.target.value,
                                                field: 'UnitPriceExclTax',
                                                idx: itemIndex
                                            });
                                        }}
                                        type="number"
                                        value={cardValue?.UnitPriceExclTax}
                                    />
                                </div>

                                <div className="sticky bottom-0 w-full h-20 p-5 grid grid-cols-2 items-center justify-end ">
                                    <div></div>
                                    <div className=' grid grid-cols-3 gap-3'>
                                        <div>
                                            <InputLabelContainer label="Tax Amount" />
                                            <InputLabelContainer label={currency(cardValue?.TaxAmount || 0)} />
                                        </div>
                                        <div>
                                            <InputLabelContainer label="Total" />
                                            <InputLabelContainer label={currency(cardValue?.Total || 0)} />
                                        </div>
                                        <div>
                                            <InputLabelContainer label="Grand Total" />
                                            <InputLabelContainer label={currency(cardValue?.GrandTotal || 0)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                }
                expandedPanel="Item Properties"
                headerTitle="Item Properties"
            />
        </>
    )
}